import LoyaltySuccessModal from './loyalty-success-modal.vue';

export default LoyaltySuccessModal;
